import './styles/Toolbar.scss';

import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import SettingsIcon from '@mui/icons-material/Settings';
import {
  useTheme,
  Button,
  ButtonGroup,
  IconButton,
  Typography,
  useMediaQuery
} from '@mui/material';

import clsx from 'clsx';
import { Dispatch, FunctionComponent, SetStateAction } from 'react';
import { ToolbarProps } from 'react-big-calendar';

interface Props extends ToolbarProps {
  openDrawer: Dispatch<SetStateAction<boolean>>;
}

const navigateMapping = {
  PREVIOUS: 'PREV',
  NEXT: 'NEXT',
  TODAY: 'TODAY',
  DATE: 'DATE'
};

export const Toolbar: FunctionComponent<Props> = props => {
  const theme = useTheme();
  const smallAndDown = useMediaQuery(theme.breakpoints.down('xs'));
  const {
    localizer: { messages },
    label,
    openDrawer
  } = props;

  const navigate = action => {
    props.onNavigate(action);
  };

  const handleViewChange = view => {
    props.onView(view);
  };

  const viewNamesGroup = messages => {
    let viewNames = props.views;
    const view = props.view;

    if (Object.keys(viewNames).length > 1) {
      return (
        <ButtonGroup color="secondary" aria-label="outlined primary button group">
          {Object.values(viewNames).map(name => (
            <Button
              variant="outlined"
              key={name.toString()}
              size="small"
              className={clsx({ 'buttongroup-button--active': view === name })}
              onClick={() => handleViewChange(name)}
            >
              {messages[name]}
            </Button>
          ))}
        </ButtonGroup>
      );
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        flexDirection: smallAndDown ? 'column' : 'row'
      }}
    >
      <span style={{ whiteSpace: 'nowrap' }}>
        <IconButton onClick={() => navigate(navigateMapping.PREVIOUS)}>
          <NavigateBeforeIcon />
        </IconButton>
        <Button variant="text" onClick={() => navigate(navigateMapping.TODAY)}>
          {messages.today}
        </Button>
        <IconButton onClick={() => navigate(navigateMapping.NEXT)}>
          <NavigateNextIcon />
        </IconButton>
      </span>

      <span className="rbc-toolbar-label" style={{ whiteSpace: 'nowrap' }}>
        <Typography style={{ fontWeight: 'bold', margin: smallAndDown ? '0.5em' : '1em' }}>
          {<>{label}</>}
        </Typography>
      </span>

      <span style={{ whiteSpace: 'nowrap' }}>
        {viewNamesGroup(messages)}
        <IconButton
          aria-label="open"
          onClick={() => openDrawer(old => !old)}
          size="medium"
          style={{
            marginLeft: '0.4em',
            marginRight: '0.4em'
          }}
        >
          <SettingsIcon />
        </IconButton>
      </span>
    </div>
  );
};
